import * as React from 'react'
import Card from '@mui/material/Card'
import CardActionArea from '@mui/material/CardActionArea'
import Box from '@mui/material/Box'
import CardContent from '@mui/material/CardContent'
import CardMedia from '@mui/material/CardMedia'
import Typography from '@mui/material/Typography'
import useMediaQuery from '@mui/material/useMediaQuery'

const getImagePath = name => `/images/${name}.png`

import { DialogsContext } from '../DialogsContext'
import { UserContext } from '../UserContext'
import { sendToAnalytics } from '../Analytics'

export default function MenuItem({ name, description, img, url, type, source }) {
    const {
        activeImportDialog,
        setActiveImportDialog,
        openImportDialog,
        closeImportDialog,
    } = React.useContext(DialogsContext)
    const { username } = React.useContext(UserContext)

    if (!url) url = 'https://google.com'

    const isMobile = useMediaQuery('(max-width:600px)')

    return (
        <Card
            sx={{
                width: isMobile ? 150 : 240,
                height: isMobile ? 80 : 104,
                pl: 0,
                borderRadius: '16px',
            }}
        >
            <CardActionArea
                onClick={() => {
                    /**
                     * TODO: REPLACE WITH react router link once react-route is defined
                     */
                    // navigate(url)

                    // Mirrors QuickStartSection's openImport tracking so grid
                    // tile clicks are distinguishable from other dialog opens
                    // (choose_import_app fires on every dialog open app-wide).
                    if (source) {
                        sendToAnalytics({
                            userId: username,
                            event: 'create_new_graph',
                            data: { source, type: type || 'link', name },
                        })
                    }

                    switch (type) {
                        case 'textEditor':
                            setActiveImportDialog('textEditor')
                            return
                        case 'mindmapImport':
                            setActiveImportDialog('mindmapImport')
                            return
                        case 'pkmImport':
                            setActiveImportDialog('pkmImport')
                            return
                        case 'textImport':
                            setActiveImportDialog('textImport')
                            return
                        case 'shortTextImport':
                            setActiveImportDialog('shortTextImport')
                            return
                        case 'textFilesImport':
                            setActiveImportDialog('textFilesImport')
                            return
                        case 'mdFilesImport':
                            setActiveImportDialog('mdFilesImport')
                            return
                        case 'srtFilesImport':
                            setActiveImportDialog('srtFilesImport')
                            return
                        case 'csvFileImport':
                            setActiveImportDialog('csvFileImport')
                            return
                        case 'jsonFileImport':
                            setActiveImportDialog('jsonFileImport')
                            return
                        case 'gexfFileImport':
                            setActiveImportDialog('gexfFileImport')
                            return
                        case 'networkxFileImport':
                            setActiveImportDialog('networkxFileImport')
                            return
                        case 'google':
                            setActiveImportDialog('google')
                            return
                        case 'searchResultsImport':
                            setActiveImportDialog('searchResultsImport')
                            return
                        case 'keywords':
                            setActiveImportDialog('keywords')
                            return
                        case 'seo':
                            setActiveImportDialog('seo')
                            return
                        case 'niche':
                            setActiveImportDialog('niche')
                            return
                        case 'scholar':
                            setActiveImportDialog('scholar')
                            return
                        case 'patents':
                            setActiveImportDialog('patents')
                            return
                        case 'twitter':
                            setActiveImportDialog('twitter')
                            return
                        case 'science':
                            setActiveImportDialog('science')
                            return
                        case 'urls':
                            setActiveImportDialog('urls')
                            return
                        case 'linkImport':
                            setActiveImportDialog('linkImport')
                            return
                        case 'youtubeKeywords':
                            setActiveImportDialog('youtubeKeywords')
                            return
                        case 'youtubeVideos':
                            setActiveImportDialog('youtubeVideos')
                            return
                        case 'youtubeComments':
                            setActiveImportDialog('youtubeComments')
                            return
                        case 'youtubeSubtitles':
                            setActiveImportDialog('youtubeSubtitles')
                            return
                        case 'youtubeChannel':
                            setActiveImportDialog('youtubeChannel')
                            return
                        case 'news':
                            setActiveImportDialog('news')
                            return
                        case 'rss':
                            setActiveImportDialog('rss')
                            return
                        case 'amazonReviews':
                            setActiveImportDialog('amazonReviews')
                            return
                        case 'amazonProducts':
                            setActiveImportDialog('amazonProducts')
                            return
                        case 'aiTopics':
                        case 'aiTopicsLlm':
                            setActiveImportDialog('aiTopics')
                            return
                        case 'aiOntologies':
                            setActiveImportDialog('aiOntologies')
                            return
                        case 'aiGraphs':
                            setActiveImportDialog('aiGraphs')
                            return
                        case 'aiChat':
                            setActiveImportDialog('aiChat')
                            return
                        case 'aiIdea':
                            setActiveImportDialog('aiIdea')
                            return
                        case 'syncImport':
                            setActiveImportDialog('syncImport')
                            return
                        case 'textMining':
                            setActiveImportDialog('textMining')
                            return
                        case 'qualitativeImport':
                            setActiveImportDialog('qualitativeImport')
                            return
                        case 'allImport':
                            setActiveImportDialog('allImport')
                            return
                        case 'import':
                            setActiveImportDialog('import')
                            return
                        default:
                            break
                        // window.location.href = url
                    }
                    window.location.href = url
                }}
                sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    height: '100%',
                }}
            >
                <CardMedia
                    src={img}
                    component="img"
                    image={getImagePath(img)}
                    alt="img"
                    sx={{
                        width: 40,
                        height: 40,
                        marginLeft: theme => theme.spacing(2),
                    }}
                />
                <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                    <CardContent sx={{ flex: '1 0 auto' }}>
                        <Typography
                            variant={isMobile ? 'body2' : 'body1'}
                            component="div"
                        >
                            {name}
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                            {isMobile ? '' : description}
                        </Typography>
                    </CardContent>
                </Box>
            </CardActionArea>
        </Card>
    )
}
